import * as angular from "angular";
import {IController, IWindowService} from "angular";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {SchedulingProjectDialogService} from "../../services/scheduling-project-dialog.service";
import * as _ from "lodash";
import * as moment from "moment";
import {VisitPlanStatusEnum} from "../../enums/visit-plan-status.enum";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {VisitPlanFacadeService} from "../../angular/services/visit-plan-facade.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {SchedulingProjectAlertsService} from "../../services/scheduling-project-alerts.service";
import {Subscription} from "rxjs";
import {
  VisitPlanScheduleStatusColorMap,
  VisitPlanScheduleStatusEnum
} from "../../enums/visit-plan-schedule-status.enum";
import {SchedulingProjectStatusEnum} from "../../enums/scheduling-project-status.enum";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {SchedulingProjectFilterCascadeService} from "../../services/scheduling-project-filter-cascade.service";
import {VisitPlanFilterSettingsService} from "../../services/visit-plan-filter-settings.service";
import {VisitPlanFilterModel} from "../../models/visit-plan-filter.model";

export class SchedulingProjectVisitPlanCalendarViewComponent implements IController {


  from: number;
  to: number;
  branchIds: string[];
  groupIds: string[];
  tags: string[];
  serviceAreaIds: string[];
  templateIds?: string[];
  statuses: VisitPlanStatusEnum[];
  schedulingProjectStatuses: SchedulingProjectStatusEnum[];


  public isArchive: boolean = false;
  public createdByCurrentUser: boolean = true;
  public views: string[];
  public eventLimit: number;
  public selectedView: string;
  public viewType: string = '/calendar';
  public events: any[];
  public visitPlanStatuses: string[] = Object.keys(VisitPlanStatusEnum);
  public schedulingProjectOptions: string[];
  public visitPlansSubscription: Subscription;
  public visitPlans: VisitPlanModel[];
  public filteredBranchIds: string[];
  public filteredGroupIds: string[];
  public queryString?: string;
  public showSideNav: boolean = true;

  private tagsFilterSynced: boolean;


  constructor(private schedulingProjectDialogService: SchedulingProjectDialogService,
              private commonsService: CommonsService, private $state, private visitPlanFacadeService: VisitPlanFacadeService,
              private confirmDialogService: ConfirmDialogService, private $filter, private $timeout,
              private commonsFacadeService: CommonsFacadeService, private schedulingProjectAlertsService: SchedulingProjectAlertsService,
              private IAMPermissions, private moment, private siteContextService: SiteContextService, private splitService: SplitService,
              private schedulingProjectFilterCascadeService: SchedulingProjectFilterCascadeService,
              private visitPlanFilterSettingsService: VisitPlanFilterSettingsService,
              private $window: IWindowService, private $log) {
  }

  $onInit() {

    this.schedulingProjectOptions = [SchedulingProjectStatusEnum.Active, SchedulingProjectStatusEnum.Planning, SchedulingProjectStatusEnum.Executing, SchedulingProjectStatusEnum.Closed];

    if (this.IAMPermissions.hasRole('super.owner')) {
      this.schedulingProjectOptions.unshift(SchedulingProjectStatusEnum.Importing);
    }

    this.views = ['basicWeek', 'month'];
    this.eventLimit = 7;
    this.selectedView = 'month';

    this.visitPlansSubscription = this.visitPlanFacadeService.selectAll().subscribe((visitPlans: VisitPlanModel[]) => {
      if (!visitPlans?.length) {
        this.visitPlans = [];
        this.events = [];
      } else {
        this.visitPlans = angular.copy(visitPlans) as VisitPlanModel[];
        this.events = this.convertVisitPlansToEvents();
      }
      this.$timeout(() => {
      }, 0)
    })
  }

  $onDestroy() {
    this.visitPlansSubscription.unsubscribe();
  }

  onViewRender(from, to) {
    this.from = from.valueOf();
    this.to = to.valueOf();
    this._saveFilterState();
    if (this.tags?.length && !this.tagsFilterSynced) {
      this.tagsFilterSynced = true;
      this._applyTagsFilterChange(true);
      return;
    }
    this.getVisitPlans();
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  onChangeViewType(view: string) {
    if (this.viewType === view) return;
    this.viewType = view;
    this.$state.go(view === '/calendar' ? '^.calendar' : '^.table', this._getStateParams(), {notify: true, reload: false});
  }

  onChangeSideNav(isEnabled: boolean) {
    this.showSideNav = isEnabled;
  }

  onCreateVisitPlan(event, sourceVisitPlan?: VisitPlanModel) {
    this.schedulingProjectDialogService.createVisitPlan(event, sourceVisitPlan)
      .then((visitPlan: VisitPlanModel) => {
        this._createVisitPlan(visitPlan);
      })
      .catch(error => console.error(error));
  }

  onEventClick(item, $event) {
    const actions = [];

    if (item.eventRef?.isArchive) {
      if (this.IAMPermissions.hasPermission('schedulingProject.visitPlan.delete')) {
        actions.push('Restore');
      }
    } else {
      actions.push('Enter');

      if (this.IAMPermissions.hasPermission('schedulingProject.visitPlan.update')) {
        actions.push('Open in new tab', 'Delete');
      }

      if (this.IAMPermissions.hasPermission('schedulingProject.visitPlan.create')) {
        actions.push('Duplicate');
      }
    }

    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Enter') {
          this.$state.go('scheduling-project.visit-plan', {
            id: item.id
          }, {notify: true, reload: false});
        }
        if (reason === 'Open in new tab') {
          const url = this.$state.href('scheduling-project.visit-plan', {id: item.id});
          this.$window.open(url, '_blank');
        }
        if (reason === 'Delete') {
          this.onDeleteVisitPlan(item.eventRef);
        }
        if (reason === 'Restore') {
          this.onRestoreVisitPlan(item.eventRef);
        }
        if (reason === 'Duplicate') {
          this.onCreateVisitPlan($event, item.eventRef);
        }
      })
  }

  onEditVisitPlan(visitPlan: VisitPlanModel) {
    if (!visitPlan) return;

    this.schedulingProjectDialogService.editVisitPlanName(visitPlan)
      .then((updatedVisitPlan: VisitPlanModel) => {
        this.commonsFacadeService.setLoaderOn();
        this.visitPlanFacadeService.updateVisitPlanName(updatedVisitPlan)
          .subscribe({
            next: (updatedVisitPlan: VisitPlanModel) => {
              this.schedulingProjectAlertsService.updateVisitPlanSuccess();
              // Store update will trigger subscription, so no need to manually update local state
            },
            error: () => {
              this.schedulingProjectAlertsService.updateVisitPlanError();
              this.commonsFacadeService.setLoaderOff();
            },
            complete: () => {
              this.commonsFacadeService.setLoaderOff();
            }
          });
      })
      .catch(() => { });
  }

  onDeleteVisitPlan(visitPlan: VisitPlanModel) {
    const text = `Are you sure you want to delete the project ${visitPlan.name ? `"${visitPlan.name}"` : ""}?`;
    this.confirmDialogService.confirm('Delete Project', text, undefined)
      .then(() => {
        this.visitPlanFacadeService.deleteOne(visitPlan.id);
      });
  }

  onRestoreVisitPlan(visitPlan: VisitPlanModel) {
    const text = `Are you sure you want to restore the project ${visitPlan.name ? `"${visitPlan.name}"` : ""}?`;
    this.confirmDialogService.confirm('Restore Project', text, undefined)
      .then(() => {
        this.visitPlanFacadeService.restoreOne(visitPlan.id);
      });
  }

  onBranchesSelect(branchIds: string[]) {
    if (branchIds === this.branchIds) return;
    this.branchIds = branchIds;
    // this._setStateParams();
    this._saveFilterState();
    this.getVisitPlans();
  }

  onTemplatesSelect(templateIds: string[]) {
    if (templateIds === this.templateIds) return;
    this.templateIds = templateIds;
    // this._setStateParams();
    this._saveFilterState();
    this.getVisitPlans();
  }

  onTagsSelect(tags: string[]) {
    if (_.isEqual(tags, this.tags)) return;
    this.tags = tags || [];
    this._applyTagsFilterChange(true);
  }

  onGroupsSelect(groupIds: string[]) {
    if (_.isEqual(groupIds, this.groupIds)) return;
    this.groupIds = groupIds;

    if (groupIds?.length) {
      this._applyBranchesFromGroups(groupIds, true);
    } else {
      this.filteredBranchIds = undefined;
      this.branchIds = [];
      this._saveFilterState();
      this.getVisitPlans();
    }
  }

  onServiceAreasSelect(serviceAreaIds: string[]) {
    if (serviceAreaIds === this.serviceAreaIds) return;
    this.serviceAreaIds = serviceAreaIds;
    // this._setStateParams();
    this._saveFilterState();
    this.getVisitPlans();
  }

  onChangeVisitPlanStatuses(visitPlanStatuses: VisitPlanStatusEnum[]) {
    this.statuses = visitPlanStatuses;
    this._saveFilterState();
    this.getVisitPlans();
  }

  onChangeSchedulingProjectStatuses(schedulingProjectStatuses: SchedulingProjectStatusEnum[]) {
    this.schedulingProjectStatuses = schedulingProjectStatuses || [];
    this._saveFilterState();
    this.getVisitPlans();
  }

  onChangeIsArchive(isArchive) {
    this.isArchive = isArchive;
    this._saveFilterState();
    this.getVisitPlans();
  }

  onChangeCreatedByCurrentUser(createdByCurrentUser: boolean) {
    this.createdByCurrentUser = !!createdByCurrentUser;
    this._saveFilterState();
    this.getVisitPlans();
  }

  private _applyTagsFilterChange(reload: boolean) {
    this.schedulingProjectFilterCascadeService.applyTagsFilter(this.tags)
      .then((state) => {
        this.filteredGroupIds = state.filteredGroupIds;
        this.groupIds = state.groupIds;
        this.filteredBranchIds = state.filteredBranchIds;
        this.branchIds = state.branchIds;
        this._saveFilterState();
        if (reload) {
          this.getVisitPlans();
        }
      })
      .catch((error) => {
        if (error?.stale) {
          return;
        }
        this.filteredGroupIds = undefined;
        this.groupIds = [];
        this.filteredBranchIds = undefined;
        this.branchIds = [];
        this._saveFilterState();
        if (reload) {
          this.getVisitPlans();
        }
      })
      .finally(() => this.$timeout(() => {}, 0));
  }

  private _applyBranchesFromGroups(groupIds: string[], reload: boolean) {
    this.schedulingProjectFilterCascadeService.applyBranchesFromGroups(groupIds)
      .then((state) => {
        this.filteredBranchIds = state.filteredBranchIds;
        this.branchIds = state.branchIds;
        this._saveFilterState();
        if (reload) {
          this.getVisitPlans();
        }
      })
      .catch((error) => {
        if (error?.stale) {
          return;
        }
        this.filteredBranchIds = undefined;
        this.branchIds = [];
        this._saveFilterState();
        if (reload) {
          this.getVisitPlans();
        }
      })
      .finally(() => this.$timeout(() => {}, 0));
  }

  private _saveFilterState() {
    this.visitPlanFilterSettingsService.setFilters(this._getStateParams());
  }

  private getVisitPlans() {
    this.visitPlanFacadeService.clearStore();
    this.visitPlanFacadeService.getMany(this._getFilter(), this._getPaginationParams());
  }

  // private _setStateParams() {
  //   this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
  // }

  private _getPaginationParams() {
    return {
      size: 500
    };
  }

  private _getFilter(): VisitPlanFilterModel {
    const filter: VisitPlanFilterModel = {
      from: this.from,
      to: this.to,
      isArchive: this.isArchive,
      createdByCurrentUser: this.createdByCurrentUser
    };

    if (!_.isEmpty(this.branchIds)) {
      filter.branchIds = this.branchIds;
    }
    if (!_.isEmpty(this.serviceAreaIds)) {
      filter.areaIds = this.serviceAreaIds;
    }
    if (!_.isEmpty(this.statuses)) {
      filter.statuses = this.statuses;
    }
    if (!_.isEmpty(this.templateIds)) {
      filter.templateIds = this.templateIds;
    }
    if (!_.isEmpty(this.schedulingProjectStatuses)) {
      filter.schedulingProjectStatuses = this.schedulingProjectStatuses;
    }

    return filter;
  }

  private _getStateParams() {
    return {
      branchIds: this.branchIds,
      groupIds: this.groupIds,
      tags: this.tags,
      serviceAreaIds: this.serviceAreaIds,
      statuses: this.statuses,
      templateIds: this.templateIds,
      from: this.from,
      to: this.to,
      schedulingProjectStatuses: this.schedulingProjectStatuses,
      isArchive: this.isArchive,
      createdByCurrentUser: this.createdByCurrentUser
    };
  }

  private convertVisitPlansToEvents(): any[] {
    return _.map(this.visitPlans, (v, index): any => {
      // Deleted (archived) projects are marked right before the name so the indication is visible on the event itself
      const deletedIndication = !!v.isArchive ? `[${this.$filter('translate')('DELETED')}] ` : '';
      return {
        id: v.id,
        index: index,
        eventRef: v,
        title: `${deletedIndication}${v.name} - ${this.$filter('translate')('SCHEDULING_PROJECT_STATUS.' + v.schedulingProjectStatus)} - ${this.$filter('bringozDate')({date: v.from}, 'date')} - ${this.$filter('bringozDate')({date: v.to}, 'date')}`,
        start: moment(v.from),
        end: moment(v.to),
        className: !!v.isArchive ? 'deleted-project-event' : undefined,
        color: VisitPlanScheduleStatusColorMap[v.scheduleStatus || VisitPlanScheduleStatusEnum.NOT_PLANNED]
      }
    });
  }

  private _createVisitPlan(visitPlan: VisitPlanModel) {

    this.commonsFacadeService.setLoaderOn();
    this.visitPlanFacadeService.createOne(visitPlan)
      .subscribe({
        next: (visitPlan: VisitPlanModel) => {
          this.schedulingProjectAlertsService.createVisitPlanSuccess();
          this.$state.go('scheduling-project.visit-plan', {
            id: visitPlan.id
          }, {notify: true, reload: false});
        },
        error: () => {
          this.schedulingProjectAlertsService.createVisitPlanError();
          this.commonsFacadeService.setLoaderOff();
        },
        complete: () => {
          this.commonsFacadeService.setLoaderOff();
        }
      })

  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectVisitPlanCalendarView', {
    bindings: {
      // visitPlans: '<',
      from: '<',
      to: '<',
      branchIds: '<?',
      groupIds: '<?',
      tags: '<?',
      serviceAreaIds: '<?',
      statuses: '<?',
      templateIds: '<?',
      schedulingProjectStatuses: '<?',
      isArchive: '<?',
      createdByCurrentUser: '<?'
    },
    template: require('./scheduling-project-visit-plan-calendar-view.html').default,
    controller: SchedulingProjectVisitPlanCalendarViewComponent
  });
